import { Base } from '../../../base/components/base'
import { Canvas } from '../../../base/components/native/canvas'
import ldb from '../../../base/lib/ldb'
import state from '../../../base/services/state'
import { IProduct, IProductVariant } from '../../../interfaces/product'

export const ProductCanvas = (product: IProduct) => {

    const [getDesign] = state.use<string>('design', ldb.get('design-url'))
    const base = Canvas(600, 600)
    const context = base.context
    base.on('mounted', () => render())
    // base.el.onclick = () => window.open(getDesign(), '_blank') // or preview
    
    base.cssClass({
        marginBottom: '-86px',
        marginTop: '-56px',
        borderRadius: '20px',
        transform: 'scale(0.7)',
        cursor: 'pointer',
    })

    async function render(prop: any = {}) {
        try{
        
        context.fillStyle = 'white'
        context.fillRect(0, 0, 600, 600)
        const variant = product.variants.find((v) => v.size === prop.name) || product.variants.find((v) => v.color === prop.name) || product.variants[0]
        
        const { designWidth, designHeight, designX, designY } = variant
        const backgroundImage = variant.image
        const background = await loadImage(backgroundImage)
        let mode = designWidth > designHeight ? 'landscape' : 'portrait'
        let ratio = 1
        if (mode === 'landscape') {
            ratio = 600 / background.width
            base.el.height = ratio * background.height
        } else {
            ratio = 600 / background.height
            base.el.width = ratio * background.width
        }
        const H = mode === 'portrait' ? 600 : ratio * background.height
        const W = mode === 'landscape' ? 600 : ratio * background.width

        context.drawImage(background, 0, 0, W, H)
        if (!getDesign()) return
        const design = await loadImage(getDesign())
        let x = designX * ratio
        let y = designY * ratio
        let tx = 0
        let ty = 0
        let dw = designWidth * ratio
        let dh = designHeight * ratio


        if (variant.mask) {
            const dummyCtx = Canvas(designWidth, designHeight).context
            const mask = await loadImage(variant.mask)
            dummyCtx.drawImage(mask, 0, 0, designWidth, designHeight)
            dummyCtx.globalCompositeOperation = 'source-in'
            dummyCtx.drawImage(design, 0, 0, designWidth, designHeight)
            const sourceImageData = dummyCtx.getImageData(0, 0, designWidth, designHeight)
            const targetImageData = context.getImageData(x, y, designWidth, designHeight)
            applyAlpha(sourceImageData, targetImageData)
            context.putImageData(targetImageData, x, y)
            base.emit('render', { ...variant, preview: base.el.toDataURL('image/jpeg', 0.82) })


        } else {
            const based = context.getImageData(x, y, dw, dh)
            const basePixels = based.data
            context.beginPath()
            context.rect(x, y, dw, dh)
            context.clip()
            const nw = mode === 'landscape' ? dw : dw * designHeight / designWidth
            const nh = mode === 'portrait' ? dh : dh * designWidth / designHeight
            context.drawImage(design, x, y, nw, nh)

            const imgd = context.getImageData(x, y, dw, dh)
            const targetPixels = imgd.data
            for (var i = 0, n = targetPixels.length; i < n; i += 4) {
                var r = targetPixels[i],
                    g = targetPixels[i + 1],
                    b = targetPixels[i + 2]
                // if (r > 250 && g > 250 && b > 250) {
                //     targetPixels[i + 0] = basePixels[i + 0]
                //     targetPixels[i + 1] = basePixels[i + 1]
                //     targetPixels[i + 2] = basePixels[i + 2]
                //     // pix[i + 3] = pixd[i + 3]
                // }
            }
            context.putImageData(imgd, x, y)
            base.emit('render', { ...variant, preview: base.el.toDataURL('image/jpeg', 0.82) })

            let isDragging = false
            let startX = 0, startY = 0

            base.el.onmousedown = (event) => {
                let mouseX = event.offsetX// event.clientX - base.el.scrollTop  - base.el.getBoundingClientRect().left
                let mouseY = event.offsetY// event.clientY - base.el.scrollLeft  - base.el.getBoundingClientRect().top
                if (mouseX >= x && mouseX <= x + dw && mouseY >= y && mouseY <= y + dh) {
                    startX = mouseX
                    startY = mouseY
                    isDragging = true
                }
            }
            base.el.onmousemove = (event) => {
                if (designHeight === designWidth) return

                let mouseX = event.offsetX
                let mouseY = event.offsetY
                // Check if the mouse is over a specific region of the canvas
                if (mouseX >= x && mouseX <= x + dw && mouseY >= y && mouseY <= y + dh) {
                    base.el.style.cursor = 'move'
                } else {
                    base.el.style.cursor = "default"
                }
                if (isDragging) {
                    const nw = mode === 'landscape' ? dw : dw * designHeight / designWidth
                    const nh = mode === 'portrait' ? dh : dh * designWidth / designHeight
                    const mouseX = event.offsetX
                    const mouseY = event.offsetY
                    let dx = mouseX - startX + tx
                    let dy = mouseY - startY + ty
                    const diffW = nw - dw
                    const diffH = nh - dh

                    if (mode === 'landscape') {
                        if (dy < -diffH) dy = -diffH
                        if (dy > 0) dy = 0
                        dx = 0
                    } else {
                        if (dx < -diffW) dx = -diffW
                        if (dx > 0) dx = 0
                        dy = 0
                    }


                    // Move the shape

                    const basePixels = based.data
                    context.beginPath()
                    context.rect(x, y, dw, dh)
                    context.clip()

                    context.drawImage(design, x + dx, y + dy, nw, nh)

                    const imgd = context.getImageData(x, y, dw, dh)
                    const targetPixels = imgd.data
                    for (var i = 0, n = targetPixels.length; i < n; i += 4) {
                        var r = targetPixels[i],
                            g = targetPixels[i + 1],
                            b = targetPixels[i + 2]
                        // if (r > 250 && g > 250 && b > 250) {
                        //     targetPixels[i + 0] = basePixels[i + 0]
                        //     targetPixels[i + 1] = basePixels[i + 1]
                        //     targetPixels[i + 2] = basePixels[i + 2]
                        //     // pix[i + 3] = pixd[i + 3]
                        // }
                    }
                    context.putImageData(imgd, x, y)
                }
            }
            base.el.onmouseup = (event) => {
                isDragging = false
                tx += event.offsetX - startX
                ty += event.offsetY - startY
                base.emit('render', { ...variant, preview: base.el.toDataURL('image/jpeg', 0.82) })

            }
        }
    } catch (err) {
        console.log(err)
    }
    }

    return Object.assign(base, {
        render
    })
}
function applyAlpha(sourceImageData: ImageData, targetImageData: ImageData) {
    for (let i = 0; i < sourceImageData.data.length; i += 4) {
        // Extract the color values
        let r = sourceImageData.data[i]
        let g = sourceImageData.data[i + 1]
        let b = sourceImageData.data[i + 2]
        let a = sourceImageData.data[i + 3]

        // Apply the alpha value to the corresponding pixel in the target image data
        let targetIndex = i
        targetImageData.data[targetIndex] = (r * a + targetImageData.data[targetIndex] * (255 - a)) / 255
        targetIndex++
        targetImageData.data[targetIndex] = (g * a + targetImageData.data[targetIndex] * (255 - a)) / 255
        targetIndex++
        targetImageData.data[targetIndex] = (b * a + targetImageData.data[targetIndex] * (255 - a)) / 255
        targetIndex++
        targetImageData.data[targetIndex] = 255
    }
}

function loadImage(source: string) {
    return new Promise<HTMLImageElement>((resolve, reject) => {
        const image = new Image()
        image.onload = () => resolve(image)
        image.onerror = reject // Todo: default image
        image.src = source
    })
}